import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ClientsSection } from './components/ClientsSection';
import { ServicesSection } from './components/ServicesSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { PricingPage } from './components/PricingPage';
import { AboutPage } from './components/AboutPage';
import { AdminLogin } from './components/AdminLogin';
import { AdminDashboard } from './components/AdminDashboard';
import { VisitorTracker } from './components/VisitorTracker';
import { CookieConsent } from './components/CookieConsent';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './contexts/LanguageContext';
import { AdminProvider } from './contexts/AdminContext';

function App() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrolled = window.scrollY;
      const progress = scrolled / documentHeight;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Calculate background color based on scroll progress
  const getBackgroundColor = () => {
    let yellowIntensity;
    
    if (scrollProgress <= 0.5) {
      yellowIntensity = scrollProgress * 2; // 0 to 1
    } else {
      yellowIntensity = (1 - scrollProgress) * 2; // 1 to 0
    }

    // Base dark slate color
    const slate = { r: 15, g: 23, b: 42 };
    // Warmer yellow-orange tint for more visible effect
    const warm = { r: 80, g: 50, b: 20 };
    
    const r = Math.round(slate.r + (warm.r - slate.r) * yellowIntensity);
    const g = Math.round(slate.g + (warm.g - slate.g) * yellowIntensity);
    const b = Math.round(slate.b + (warm.b - slate.b) * yellowIntensity);

    return `rgb(${r}, ${g}, ${b})`;
  };

  return (
    <LanguageProvider>
      <AdminProvider>
        <BrowserRouter>
          <div 
            className="App"
            style={{
              backgroundColor: getBackgroundColor(),
              transition: 'background-color 0.3s ease-out'
            }}
          >
            <VisitorTracker />
            <Routes>
              <Route path="/" element={
                <>
                  <Header />
                  <Hero />
                  <ClientsSection />
                  <ServicesSection />
                  <ContactSection />
                  <Footer />
                </>
              } />
              <Route path="/pricing" element={
                <>
                  <Header />
                  <PricingPage />
                  <Footer />
                </>
              } />
              <Route path="/about" element={
                <>
                  <Header />
                  <AboutPage />
                  <Footer />
                </>
              } />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
            <CookieConsent />
            <Toaster />
          </div>
        </BrowserRouter>
      </AdminProvider>
    </LanguageProvider>
  );
}

export default App;
